import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { observer } from 'mobx-react-lite';
import globalPaymentServices from '../../../../../stores/global-payment-services';
import appApi from '../../../../../api/app-api';
import { PaymentServiceWithVersionsResponseType } from '../../../../../api/types/payments/payment-template';

interface PaymentServiceSelectorProps {
  selectedPaymentServiceId: number | null;
  onPaymentServiceChange: (
    paymentServiceId: number | null,
    paymentServiceVersionId: number | null,
  ) => void;
  disabled?: boolean;
}

export const PaymentServiceSelector: React.FC<PaymentServiceSelectorProps> =
  observer(({ selectedPaymentServiceId, onPaymentServiceChange, disabled }) => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      const fetchPaymentServices = async () => {
        if (globalPaymentServices.services.length === 0) {
          setLoading(true);
          const res = await appApi.getAllPaymentServices();
          globalPaymentServices.services = res.data.body;
          setLoading(false);
        }
      };
      fetchPaymentServices();
    }, []);

    const selectedService = globalPaymentServices.services.find(
      (s) => s.id === selectedPaymentServiceId,
    );

    return (
      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            fontSize: '14px',
            color: '#4b5563',
            marginBottom: '8px',
            display: 'block',
          }}
        >
          שירות תשלום
        </label>
        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו שירותי תשלום</div>
          }
          selectionMode="single"
          selection={selectedService || null}
          onSelectionChange={(e) => {
            const service =
              e.value as PaymentServiceWithVersionsResponseType | null;
            if (service) {
              // Use versionId from service, or use the latest version if versionId is not set
              let versionId = service.versionId;
              // If versionId is not set or is 0, try to get the latest version
              if (
                !versionId &&
                service.versions &&
                service.versions.length > 0
              ) {
                // Get the latest version (usually the first one in the array, or the one with highest id)
                const latestVersion = service.versions.reduce(
                  (latest, current) =>
                    current.id > latest.id ? current : latest,
                );
                versionId = latestVersion.id;
              }
              onPaymentServiceChange(service.id, versionId || null);
            } else {
              onPaymentServiceChange(null, null);
            }
          }}
          value={globalPaymentServices.services}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
            marginTop: '8px',
          }}
          loading={loading}
          disabled={disabled}
        >
          <Column
            selectionMode="single"
            headerStyle={{ width: '3rem' }}
            disabled={disabled}
          />
          <Column
            style={{ textAlign: 'right' }}
            field="paymentServiceName"
            header="שם שרות"
          />
          <Column
            header="מחיר"
            style={{ textAlign: 'right' }}
            body={(rowData: PaymentServiceWithVersionsResponseType) => {
              return <div>₪{rowData.versions[0]?.price}</div>;
            }}
          />
        </DataTable>
      </div>
    );
  });
